import { useCallback } from "react"
import { IOpenPanel } from "../../../../../Interfaces/IPanel"
import { IRazonEdit } from "../../../../../Interfaces/auxiliar/IRazon"
import { UseRazonPanelEditar } from "./usePanelRazonEditar"
import { PanelHeader } from "../../../../../components/Panel/PanelHeader"
import { PanelFooter } from "../../../../../components/Panel/PanelFooter"
import { Panel, TextField } from "@fluentui/react"
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse"
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading"
import { ComboBoxComponent } from "../../../../../components/comboBox/ComboBoxComponent"
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic"
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer"

export interface IPanelRazonEditar extends IOpenPanel{
    item: IRazonEdit
}
export const PanelRazonEditar=(props:IPanelRazonEditar)=>{
    const {request,setRequest,putEditarRazon,loading,reset,mensaje,status,estados,categorias} =UseRazonPanelEditar(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Editar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={putEditarRazon}
              onDismiss={() => {
                 reset()
              }}
            />
          </>
        ),
        [request]
      );
      return (
        <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Editar Razón"} 
        status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
          <TextField 
         type="text"
         label="Nombre de Razón"
         placeholder="Ingrese Nombre de Razón"
         autoComplete="off"
         value={request.codigo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,codigo:newValue})}
         }}
         />
         <br/>
        <TextField 
         type="text"
         label="Descripción de Razón"
         placeholder="Ingrese Descripción de Razón"
         autoComplete="off"
         value={request.descripcion}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,descripcion:newValue})}
         }}
         />
         <ComboBoxComponent defaultSelectedOptions={estados.filter((item)=>item.key==request.estadoId)} text={"Estado"} placeholder="Seleccione Estado" data={estados} onOptionSelect={(event,option)=>{
          if(option ){
            setRequest({...request,estadoId:String(option.key)})
          }
         }}></ComboBoxComponent>
          <ComboBoxComponent text={"Categoria"} defaultSelectedOptions={categorias.filter((item)=>item.key==request.categoriaId)} placeholder="Seleccione Categoria" data={categorias} onOptionSelect={(event,option)=>{
          if(option ){
            setRequest({...request,categoriaId:String(option.key)})
          }
         }}></ComboBoxComponent>
        </PanelDrawer>
       )
}